import React from "react";
import { KTSVG } from "../../helpers/KTSVG";
import Text from "../../styleguide/Text";
import {
  getSemanticIconClasses,
  getSemanticSubtleBackgroundClasses,
  getSemanticTextClasses,
} from "../../theme/semanticClasses";

export interface CustomItemPress {
  id?: number | string;
  name: string | number;
  description?: string;
}

function CustomListItem({
  backgroundColor = "info",
  id,
  name,
  description,
  infoText,
  withIcon,
  iconName = "/media/icons/duotune/medicine/med002.svg",
  iconColor = "success",
  onClick,
  containerStyle,
}: {
  backgroundColor?: "info" | "success" | "warning" | "danger" | "primary";
  id?: number | string;
  name: string | number;
  description?: string;
  infoText?: {
    text: string;
    color?: "info" | "success" | "warning" | "danger" | "primary";
  };
  withIcon?: boolean;
  iconName?: string;
  iconColor?: string;
  onClick?: (value: CustomItemPress) => void;
  containerStyle?: React.CSSProperties;
}) {
  const handleOnItemClick = (e: any) => {
    e.preventDefault();
    onClick && onClick({ id, name, description });
  };

  return (
    <button
      type="button"
      className={`group mb-4 flex w-full items-center justify-between rounded-control border-0 p-4 text-left transition-colors hover:brightness-[0.98] focus:outline-none focus:ring-2 focus:ring-accent/20 ${getSemanticSubtleBackgroundClasses(
        backgroundColor,
      )}`}
      style={containerStyle}
      onClick={handleOnItemClick}>
      <div className="flex min-w-0 items-center text-left">
        {withIcon && (
          <KTSVG
            path={iconName}
            className={`mr-5 shrink-0 ${getSemanticIconClasses(iconColor)}`}
            svgClassName="h-6 w-6"
          />
        )}
        <div className="mr-2 min-w-0">
          {name && (
            <Text className="font-semibold text-slate-800">{name}</Text>
          )}
          {description && (
            <Text variant="body1" className="font-medium text-muted">
              {description}
            </Text>
          )}
        </div>
      </div>
      {infoText?.text && (
        <Text
          variant="body1"
          className={`shrink-0 py-1 font-semibold ${getSemanticTextClasses(
            infoText.color ?? "success",
          )}`}>
          {infoText.text}
        </Text>
      )}
    </button>
  );
}

export default CustomListItem;
